import AmexResyValueFeaturedHighlights from './AmexResyValueFeaturedHighlights';

export default AmexResyValueFeaturedHighlights;
